import { RRule } from 'rrule';
import {
  EditRecurrence,
  RecurrenceOptions,
} from 'src/graphql/entities/signal-oncall-schedule/signal-oncall-schedule.types';

export const TIME_SLOTS = [
  { label: '12:00 AM', value: '00:00:00' },
  { label: '12:30 AM', value: '00:30:00' },
  { label: '1:00 AM', value: '01:00:00' },
  { label: '1:30 AM', value: '01:30:00' },
  { label: '2:00 AM', value: '02:00:00' },
  { label: '2:30 AM', value: '02:30:00' },
  { label: '3:00 AM', value: '03:00:00' },
  { label: '3:30 AM', value: '03:30:00' },
  { label: '4:00 AM', value: '04:00:00' },
  { label: '4:30 AM', value: '04:30:00' },
  { label: '5:00 AM', value: '05:00:00' },
  { label: '5:30 AM', value: '05:30:00' },
  { label: '6:00 AM', value: '06:00:00' },
  { label: '6:30 AM', value: '06:30:00' },
  { label: '7:00 AM', value: '07:00:00' },
  { label: '7:30 AM', value: '07:30:00' },
  { label: '8:00 AM', value: '08:00:00' },
  { label: '8:30 AM', value: '08:30:00' },
  { label: '9:00 AM', value: '09:00:00' },
  { label: '9:30 AM', value: '09:30:00' },
  { label: '10:00 AM', value: '10:00:00' },
  { label: '10:30 AM', value: '10:30:00' },
  { label: '11:00 AM', value: '11:00:00' },
  { label: '11:30 AM', value: '11:30:00' },
  { label: '12:00 PM', value: '12:00:00' },
  { label: '12:30 PM', value: '12:30:00' },
  { label: '1:00 PM', value: '13:00:00' },
  { label: '1:30 PM', value: '13:30:00' },
  { label: '2:00 PM', value: '14:00:00' },
  { label: '2:30 PM', value: '14:30:00' },
  { label: '3:00 PM', value: '15:00:00' },
  { label: '3:30 PM', value: '15:30:00' },
  { label: '4:00 PM', value: '16:00:00' },
  { label: '4:30 PM', value: '16:30:00' },
  { label: '5:00 PM', value: '17:00:00' },
  { label: '5:30 PM', value: '17:30:00' },
  { label: '6:00 PM', value: '18:00:00' },
  { label: '6:30 PM', value: '18:30:00' },
  { label: '7:00 PM', value: '19:00:00' },
  { label: '7:30 PM', value: '19:30:00' },
  { label: '8:00 PM', value: '20:00:00' },
  { label: '8:30 PM', value: '20:30:00' },
  { label: '9:00 PM', value: '21:00:00' },
  { label: '9:30 PM', value: '21:30:00' },
  { label: '10:00 PM', value: '22:00:00' },
  { label: '10:30 PM', value: '22:30:00' },
  { label: '11:00 PM', value: '23:00:00' },
  { label: '11:30 PM', value: '23:30:00' },
];
export const WEEKLY_RECURRENCE_OPTIONS = [
  RecurrenceOptions.Weekly,
  RecurrenceOptions.Every2Weeks,
  RecurrenceOptions.Every3Weeks,
];
export const RECURRENCE_OPTIONS = [
  { value: RecurrenceOptions.Once, label: 'Does not repeat' },
  { value: RecurrenceOptions.Weekly, label: 'Weekly' },
  { value: RecurrenceOptions.Every2Weeks, label: 'Every 2 weeks' },
  { value: RecurrenceOptions.Every3Weeks, label: 'Every 3 weeks' },
  { value: RecurrenceOptions.Monthly, label: 'Monthly' },
  { value: RecurrenceOptions.Custom, label: 'Custom' },
];

export const RECURRENCE_PERIOD_OPTIONS = [
  { value: RRule.DAILY, label: 'Days' },
  { value: RRule.WEEKLY, label: 'Weeks' },
  { value: RRule.MONTHLY, label: 'Months' },
];

export const RECURRENCE_INTERVAL_OPTIONS = Array.from({ length: 60 }, (_, i) => i + 1).map(
  (value) => ({
    value,
    label: value.toString(),
  }),
);

export const WEEKDAYS = [
  { value: RRule.SU, label: 'Sun' },
  { value: RRule.MO, label: 'Mon' },
  { value: RRule.TU, label: 'Tue' },
  { value: RRule.WE, label: 'Wed' },
  { value: RRule.TH, label: 'Thu' },
  { value: RRule.FR, label: 'Fri' },
  { value: RRule.SA, label: 'Sat' },
];

export const UNTIL_SLOTS = [
  { value: EditRecurrence.This, label: 'This event' },
  {
    value: EditRecurrence.ThisAndFollowing,
    label: 'This and following events',
  },
];

export const TIME_SLOT_OPTIONS = [
  ...TIME_SLOTS,
  // This last option corresponds to the end of an ALL DAY event.
  { label: '11:59 PM', value: '23:59:59' },
];
